/**
 * Les différentes tailles d'icônes disponibles selon le guide de styles
 */

export enum IconSizeMap {
  small = '16px',
  smaller = '19px',
  default = '24px',
  larger = '32px',
  large = '40px',
  auto = '1em',
}

/** Les tailles d'icônes exprimées en valeurs CSS */
export type IconSize = keyof typeof IconSizeMap;

/** Icônes définies pour les types d'adresses publiques. */
type LandmarkIconName =
  | 'aeroport'
  | 'arena'
  | 'batiment'
  | 'bibliotheque'
  | 'casino'
  | 'cimetiere'
  | 'cinema'
  | 'domicile'
  | 'ecole'
  | 'gare-de-train'
  | 'general'
  | 'hopital'
  | 'hotel'
  | 'magasin'
  | 'musee'
  | 'nourriture'
  | 'parc'
  | 'piscine'
  | 'restaurant'
  | 'sport'
  | 'stade'
  | 'station-rem'
  | 'station-de-metro'
  | 'theatre'
  | 'vaccination';

type EmergenciesIconName =
  | 'emergency-exclamation'
  | 'emergency-no-internet';

type ProfilesIconName =
  | 'accessibility'
  | 'password-key'
  | 'profile'
  | 'favourite-addresses';

type ContactUsIconName =
  | 'email'
  | 'phone'
  | 'time';

/**
 * Liste des icônes disponibles sous forme d'un sprite SVG généré au build puis injecté sous l'élément `<body>`.
 * Les icônes peuvent alors être utilisées à l'aide de la composante `<SvgIcon>` qui affichera alors
 * l'icône sélectionnée avec des dimensions normalisées.
 *
 * @see https://github.com/vbenjs/vite-plugin-svg-icons
 *
 */
export type IconName =
  | 'agrandir'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-right-round'
  | 'arrow-left-round'
  | 'burger-menu'
  | 'calendar'
  | 'caret-left'
  | 'caret-right'
  | 'check-round'
  | 'clock'
  | 'close'
  | 'close-round'
  | 'collapse'
  | 'copy'
  | 'email-sent'
  | 'envelop'
  | 'envelop-round'
  | 'exclamation-round'
  | 'exclamation-round-border'
  | 'expand'
  | 'external-link'
  | 'home'
  | 'information-round'
  | 'information-round-inverted'
  | 'lightbulb'
  | 'magnifying-glass'
  | 'origin'
  | 'password-eye'
  | 'password-eye-off'
  | 'pin'
  | 'pin-outline'
  | 'plus'
  | 'print'
  | 'print-round'
  | 'question-mark-round'
  | 'question-mark-round-filled'
  | 'star'
  | 'speech-bubble'
  | 'trash'
  | 'trash-round'
  | 'edit'
  | 'circle-thumbs-up'
  | 'user'
  | ProfilesIconName
  | LandmarkIconName
  | EmergenciesIconName
  | ContactUsIconName;
